<template>
<form  class="cardForm" v-on:submit.prevent="submitForm">
    <div class="container h-100" v-show="isLoading">
            <div class="row align-items-center h-100" >
                <div class="col-8 mx-auto" style="background-color:#0d6fb8;border-radius:.375rem">
                    <div class="jumbotron" style="margin:20px">
                        <br>
                        <center>
                            <h2 style="color: white;">¡Espere mientras se envia la informacion!</h2>
                        </center>
                        <br>
                    </div>
                </div>
            </div>
        </div>
     <div class="container h-100" v-show="showdiv">
            <div class="row align-items-center h-100" >
                <div class="col-8 mx-auto" style="background-color:#0d6fb8;border-radius:.375rem">
                    <div class="jumbotron" style="margin:20px">
                        <br>
                          <br>
                        <h1 style="color: white;">Gracias por confirmar tus datos, estamos creando tu cuenta por favor valida en unos minutos tu correo, recibirás el enlace para poder acceder al portal.</h1>
                        <br>
                    </div>
                </div>
            </div>
            </div>
            <div v-show="showform">
   <center><h2>Docente</h2></center>

<div class="inputControl">
     <label :class="{ lblname : showBorder }">Nombre Docente: <span>*</span></label>
     <input  type="text" name="NombreDocente"  :class="{ bodername : showBorder }"
                   autocomplete="nope" maxlength="100" minlength="3"
     onpaste="return false" v-on:keypress="isLetter($event)" 
     oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" 
     v-on:blur="notEmpty($event)" required  v-model="form.Nombre" @input="form.Nombre=$event.target.value.toUpperCase()">
</div>
<span style="color:#b11026 !important; text-align: left;" :class="{ span : showSpan }">{{textoone}}</span>

<div class="inputControl"> 
     <label  :class="{ lblname : showBorderap }">Apellido Paterno Docente: <span>*</span></label>
     <input  type="text" name="ApellidoPaternoDocente" class="form-control" :class="{ boderap : showBorderap }"
                   autocomplete="nope" maxlength="50" minlength="3"
     onpaste="return false" v-on:keypress="isLetterap($event)"  v-on:blur="notEmptyap($event)"
     oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" 
    required  v-model="form.ApellidoPaterno" @input="form.ApellidoPaterno=$event.target.value.toUpperCase()">
</div>
<span style="color:#b11026 !important; text-align: left;" :class="{ spanap : showSpanap }">{{textapp}}</span>


<div class="inputControl"> 
     <label  :class="{ lblname : showBorderam }">Apellido Materno Docente: <span>*</span></label>
     <input  type="text" name="ApellidoMaternoDocente" class="form-control" :class="{ boderam : showBorderam }"
                   autocomplete="nope" maxlength="50" minlength="3"
     onpaste="return false" v-on:keypress="isLetteram($event)"  v-on:blur="notEmptyam($event)"
     oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" 
     required  v-model="form.ApellidoMaterno"  @input="form.ApellidoMaterno=$event.target.value.toUpperCase()">   
</div>
<span style="color:#b11026 !important; text-align: left;" :class="{ spanam : showSpanam }">{{textam}}</span>

<div class="inputControl"> 
          <label   :class="{ lblname : showBordertl }">Celular (10 d&iacute;gitos): <span>*</span></label>
          <input  type="number" name="CelularDocente" class="form-control" autocomplete="nope" maxlength="10" minlength="2"
          onpaste="return false" v-on:blur="notEmptytl($event)" :class="{ bodertl : showBordertl }" :required="disablePhone"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" 
           v-model="form.Telefono" @input="form.Telefono=$event.target.value.toUpperCase()">
</div>
<span style="color:#b11026 !important; text-align: left;" :class="{ spantl : showSpantl }">{{textotel}}</span>   

<div class="inputControl"> 
     <label :class="{ lblname : showBorderco }">Correo Docente: <span>*</span></label>
     <input  type="email" name="EmailDocente" id="EmailDocente" class="form-control" 
                   autocomplete="nope" maxlength="50" minlength="3"
     onpaste="return false"  :class="{ boderco : showBorderco }" required
     oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" 
     v-on:blur="notEmptyEmail($event)"  v-model="form.CorreoElectronico" @input="form.CorreoElectronico=$event.target.value.toUpperCase()">
</div>
<span style="color:#b11026 !important; text-align: left;" :class="{ spanco2 : showSpanco2 }">{{textcorreo}}</span> 

<div class="inputControl"  hidden="true" style="display:none">
          <label for="EdadAlumno">Turno: <span>*</span></label>
         <select name="Turno" id="Turno" v-model="form.Turno" style="border-radius:6px;border: solid 1px #5eabe0; background-color:white;padding:10px 16px; width:80%;font-size:16px;color:#505050">}
         <option value="JORNADA AMPLIA">JORNADA AMPLIA</option>
         <option value="MATUTINO">MATUTINO</option>
         <option value="VESPERTINO">VESPERTINO</option>
         </select>
</div>
    <div class="inputControl" hidden="true" style="display:none">
     <div class="col-12 col-md-10 mt-4 md-form">
                   <label class="active">Id Escuela <span>*</span></label>
                  <input  type="text" name="idSchool" class="form-control" :value="idsch" style="width:80%">
     </div>
     </div>

      <div class="inputControl" hidden="true" style="display:none">
     <div class="col-12 col-md-10 mt-4 md-form">
                   <label class="active">Tipo de Escuela <span>*</span></label>
                  <input  type="text" name="typeSchool"  class="form-control" :value="tpsch"> 
     </div>
     </div>

     <div class="inputControl">
          <p style="font-size:14px">Al hacer clic en <b style="color:#f68b1f" data-gtm-tr="Registro" data-gtm-accion="{step}" data-gtm-etiqueta="{resultado}">"Enviar Datos"</b>, reconoces haber leído las <a href="https://www.unitec.mx/politicas-de-privacidad/" target="_blank">Políticas de Privacidad</a> y confirmas estar de acuerdo con el uso de ellas, así como los <a href="https://www.unitec.mx/terminos-y-condiciones/" target="_blank">Términos y Condiciones</a> del sitio</p>
    </div> 
     
          <button type="sumbit" class="cmp-button" :disabled="btn" :class="{ spanap : showbtnsend }">Enviar Datos</button>
            </div>
          </form>
</template>

<script>
import axios from 'axios';
export default {
props:['idsch','tpsch'],
    data(){
        return{
            isLoading: false,
            showdiv: false,
            showform: true,
            btn: false,
            showbtnsend: false,
            form: {
                //ActividadAgenda:'TEST',
                Typeregister: '4',
                ApellidoMaterno: '',
                //ApellidoMaternoTutor: null,
                ApellidoPaterno: '',
                //ApellidoPaternoTutor: null,
                AreaInteres: 'PRIMER INGRESO',
                Attemp: '',
                Organizacion:'',
                Banner: '',
                BanderaRegistro: '0',
                Calidad: 'MICRO',
                Campus: '',
                Carrera:'',
                CarreraCliente: null,
                Ciclo: '23-1',
                CID: null,
                Cookie:'',
                CorreoElectronico: '',
                //CorreoElectronicoTutor: null,
                Departamento: null,
                Estado: null,
                //Edad: '21',
                //Ejecutivo: '',
                //EscuelaEmpresa: '',
                //ExtensionOficina: null,
                FechaEnvioLP: '',
                Flag_Microregistro:'1',
                FuenteNegocio:'MICRO_DOCENTE',
                FuenteObtencion:'WEB',
                //Genero: null,
                //GUIDActividAgenda: '67f6ba08-1925-eb11-a813-000d3a3ab684',
                GUIDAreaInteres: 'b0839dc4-6572-e211-b35f-6cae8b2a4ddc',
                GUIDCalidad:'',
                GUIDCampus: '',
                GUIDCarrera: '',
                GUIDCiclo: '23CDBEEC-E301-EC11-94EF-000D3A339E12',
                GUIDEstado:null,
                //GUIDEjecutivo: '',
                //GUIDEscuelaEmpresa:'',
                GUIDFuentedeObtencion:'',
                GUIDLpTransaccion: "",
                GUIDModalidad: '',
                GUIDNivel: '',
                GUIDOtroCampus: null,
                //GUIDParentescoTutor:null,
                //GUIDsubactividad:'970eaca6-c074-e211-a7b5-3440b5bef8e4',
                //GUIDSubsubactividad:'99c0c416-de1f-eb11-a813-000d3a31ee06',
                GUIDUsuario: 'd6d4012d-8aaf-e711-8104-c4346bdc0341',
                IdCarrera: null,
                IdSchool: '',
                LandingPage:'WEB',
                Marcable: null,
                Modalidad: '',
                Nivel: '',
                Nombre: '',
                //NombreTutor: null,
               // NumeroCelularTutor: null,
                OtroCampus: null,
                //ParentescoTutor:null,
                Prioridad: '',
                //RegistroKAM: '1',
                SubNivel: '2',
                //SubSubTipoActividad:'APLICACIÓN TEST',
                //SubTipoActividad:'PROMOCION ESCUELAS',
                Team: '',
                tel2predictivo:'',
                Telefono: '',
                TelefonoPredictivo: '',
                //Turno: '',
                Usuario: 'CrmDynScribe Integración',
                CorreoElectronicoCorrecto: null,
                CorreoElectronicoTutorCorrecto:null,
                TelCelularMarcableCOFETEL: null,
                TelDomicilioMarcableCOFETEL: null,
                TelTrabajoMarcableCOFETEL: null,
                TelCelularMarcableREPEP: null,
                TelDomicilioMarcableREPEP: null,
                TelTrabajoMarcableREPEP: null,
                NumCelularTutorMarcableCOFETEL: null,
                NumCelularTutorMarcableREPEP: null,
                TelCasaTutorPredMarcableCOFETEL: null,
                TelCasaTutorPredMarcableREPEP: null,
                TelTutorMarcableCOFETEL: null,
                TelTutorMarcableREPEP: null,
            },
            EscuelaEmpresa:'',
            showSpan: true,
            showBorder: false,
            showSpanap: true,
            showBorderap: false,
            showSpanam: true,
            showBorderam: false,
            showSpantl: true,
            showBordertl: false,
            showSpanco: true,
            showSpanco2: true,
            showBorderco: false,
            ejecutivo: null,
            ejecutivo_asignado_id:'',
            filteredProducts: [],
            textoone:'',
            textapp:'',
            textam:'',
            textotel:'',
            textcorreo:'',
            bandera:'',
            disablePhone:false,
            disableMail:false,
            url:process.env.VUE_APP_URL,
            urlgeneral:process.env.VUE_APP_URL_GENERAL,
            urlpost:process.env.VUE_APP_URL_POST,
            urlpostcrm:process.env.VUE_APP_URL_POST_CRM,
            urlposthub:process.env.VUE_APP_URL_POST_HUB,
            urlvalidatemailposthub:process.env.VUE_APP_URL_VALIDATEMAIL
        }
    },
     mounted() {
        //this.getFuentedenegocio();
        this.getEjecutivo();
        this.getTeampriority();
        this.forceUpper();
         //Data dummy
       axios.get( this.urlgeneral+'/api/dummy?auth=cdbf21d1e5cfee9eea8978751102632d' )
            .then(response => {
                let dataDummy = response.data;
                this.form.GUIDCarrera = dataDummy.CARRERA.id;
                this.form.GUIDModalidad = dataDummy.MODALIDAD.id;
                this.form.GUIDNivel = dataDummy.NIVEL.id;
           this.form.Carrera = dataDummy.CARRERA.label;
                this.form.Modalidad = dataDummy.MODALIDAD.label;
                   this.form.Nivel = dataDummy.NIVEL.label;
                this.form.GUIDCalidad = dataDummy.CALIDAD.id;
                localStorage.setItem( "carrera-dummy-id", dataDummy.CARRERA.id );
                localStorage.setItem( "carrera-dummy-name", dataDummy.CARRERA.label );
                localStorage.setItem( "modalidad-dummy-id", dataDummy.MODALIDAD.id );
                localStorage.setItem( "modalidad-dummy-name", dataDummy.MODALIDAD.label );
                localStorage.setItem( "nivel-dummy-id", dataDummy.NIVEL.id );
                localStorage.setItem( "nivel-dummy-name", dataDummy.NIVEL.label );
                localStorage.setItem( "calidad-dummy-id", dataDummy.CALIDAD.id );
                localStorage.setItem( "calidad-dummy-name", dataDummy.CALIDAD.label );
                this.form.GUIDCampus = dataDummy.CAMPUS.id;
                this.form.Campus = dataDummy.CAMPUS.label;
                localStorage.setItem( "campus-dummy-id", dataDummy.CAMPUS.id );
                localStorage.setItem( "campus-dummy-name", dataDummy.CAMPUS.label );
            });



             axios.get( this.urlgeneral+'/api/cicloEducando' )
            .then(response => {
                let dataCiclo = response.data[0];
               // this.form.GUIDCiclo = dataCiclo.codigo;
                //this.form.Ciclo = dataCiclo.name;
                var fuente_negocio =  this.form.FuenteNegocio;

                var ciclo =  this.form.Ciclo;
                var campus =  this.form.GUIDCampus;
                var nivel =  this.form.GUIDCarrera;
                var area_de_atencion =  this.form.AreaInteres;
                console.log(dataCiclo);
      const url =this.urlgeneral+"/team-priority?fuente_negocio="+fuente_negocio+'&ciclo='+ciclo
      +'&campus='+campus+'&nivel='+nivel+'&area_de_atencion='+area_de_atencion;
            axios.get( url )
            .then(response => {
                let dataTeam= response.data[0];
                this.form.Team = dataTeam.team;
                this.form.Prioridad = dataTeam.prioridad;
                this.form.Attemp = dataTeam.attemp;
                this.form.Organizacion = dataTeam.organizacion;
                this.form.GUIDLpTransaccion = this.getUiid();
            });
            });

    },
  methods: {
    forceUpper() {
    var domain = document.domain; 
    this.form.Cookie = domain;
    var url_string = window.location.href; 
    var url = new URL(url_string);
    var testId = url.searchParams.get("testId");
    if(testId == '' || testId == null){
    this.form.Banner = "PROSPECCION_EDUCANDO_W";
    }
    else{
        this.form.Banner = "PROSPECCION_EDUCANDO";
    }
    },
    getFuenteNegocio(calidad) {
    var f_n = '';
    if (calidad == 'A' || calidad == 'B' || calidad == 'C' || calidad == 'D') {
        f_n = 'ESCUELAS PROVEEDORAS';
    }
     else  {
        f_n = 'PROMOCION NO TRADICIONAL';
    }
    /*if( calidad ){
          fuenteNegocios = JSON.parse( localStorage.getItem( "fuente-negocios" ) );
        for( var fn = 0; fn < fuenteNegocios.length; fn++ ){
              if( fuenteNegocios[fn].calidad == calidad ){
                  f_n = fuenteNegocios[fn].name;
            }
        }
    }*/

    return f_n;
},
    getUiid(){
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
    }
    ,
    getTeampriority() {
    var fuente_negocio =  this.form.FuenteNegocio;
    var ciclo =  this.form.Ciclo;
    var campus =  this.form.GUIDCampus;
    var nivel =  this.form.GUIDCarrera;
    var area_de_atencion =  this.form.AreaInteres;
    //console.log("ciclo "+ciclo);
      const url =this.urlgeneral+"/team-priority?fuente_negocio="+fuente_negocio+'&ciclo='+ciclo
      +'&campus='+campus+'&nivel='+nivel+'&area_de_atencion='+area_de_atencion;
            axios.get( url )
            .then(response => {
                let dataTeam= response.data[0];
                this.form.Team = dataTeam.team;
                this.form.Prioridad = dataTeam.prioridad;
                this.form.Attemp = dataTeam.attemp;
                this.form.Organizacion = dataTeam.organizacion;
                this.form.GUIDLpTransaccion = this.getUiid();
            });
   
    },
   getEjecutivo() {
     var idsescuela = this.idsch;
     if(idsescuela == null || idsescuela == "null" || idsescuela == ""){
        idsescuela = 17012
     }
     this.form.IdSchool = idsescuela;
     var fechaRegistro = new Date();
     var mes =fechaRegistro.getMonth()+1;
     var fR = fechaRegistro.getFullYear()+'-'+mes+'-'+fechaRegistro.getDate()+' '+fechaRegistro.getHours()+':'+fechaRegistro.getMinutes()+':'+fechaRegistro.getSeconds();
    this.form.FechaEnvioLP = fR;
    const url ="https://www.atencionunitec.mx/api/get-ejecutivo/"+idsescuela;
    axios.get( url )
            .then(response => {
                let dataEjecutivo= response.data[0];
                this.EscuelaEmpresa = dataEjecutivo.name;
                
            });
    },
     getPhonepredectivo(){
          var phone = this.form.Telefono;
          var newphone = '9044' + phone;
          return newphone;
     },
    getTelefonoLocalPredictivo(){
          var phone = this.form.Telefono;
          var newphone = '901' + phone;
          return newphone;
     },
     getUsuario(){
          var usuario = this.form.Nombre;
          return usuario;
     },
    getidfuentedeobtencion(fuenteob){
    const url =this.url+"api/fuenteObtencion";
    axios.get( url )
    .then(response => {
    const products = response.data;
    var a = products.filter(a => a.fuente_name.includes(fuenteob));
    var extra = a[0].fuente_guid;
    //console.log("ID OBTENCION"+a[0].fuente_guid); //GUID DE WEB
    return extra;
 });
     },
     submitForm(){ 
    this.showform = false;
    this.isLoading = true; 
    this.btn=true;
    this.showbtnsend = true;
    //var telefono = this.form.Telefono; 
    var correo = this.form.CorreoElectronico;  
    if(correo == ""){
    this.disablePhone = false;
    var phone = this.form.Telefono;
    var newMail =phone+"@unitec.mx";
    this.form.CorreoElectronico = newMail;
    }

    this.form.TelefonoPredictivo =  this.form.Telefono;
    this.form.tel2predictivo =  this.form.Telefono;
     //this.form.TelefonoPredictivo = this.getPhonepredectivo();
     //this.form.TelefonoCasaPredictivo = this.getTelefonoLocalPredictivo();
     var fuenteob = this.form.FuenteObtencion;
     const url =this.urlgeneral+"/api/fuenteObtencion";
    axios.get( url )
    .then(response => {
    const products = response.data;
    var a= products.filter(a => a.fuente_name.includes(fuenteob));
    this.form.GUIDFuentedeObtencion =  a[0].fuente_guid;
    //console.log("ID OBTENCION"+a[0].fuente_guid); //GUID DE WEB
    var information = new Object();
     information.nombre = this.form.Nombre;
     information.apellidopaterno = this.form.ApellidoPaterno;
     information.apellidomaterno = this.form.ApellidoMaterno;
     information.turno = 'Matutino';
     information.edad = this.form.Edad;
     information.email = this.form.CorreoElectronico;
     localStorage.setItem("dataForm", JSON.stringify([information]));
     //var showInformation = JSON.parse(localStorage.getItem("dataForm"));
     //console.log(showInformation)
     // axios.post(this.urlpost+"/RegistroLP", this.form)
     var url_string = window.location.href; 
    var url = new URL(url_string);
    var testId = url.searchParams.get("testId");
    var typeuser = url.searchParams.get("typeUser");
    var tyschool = url.searchParams.get("typeSchool");
    let config = {
    headers: {
    'x-api-key': "5974b29d-0314-4f0c-ba82-cb27ca31913d",
    }
    }
    let configdos = {
    headers: {
    'Content-type': "application/json",
    }
    }
         this.recordseedhub = {
         email: this.form.CorreoElectronico,   
         propiedades:[
            {
                 propiedad: "lastname",
                 valor:this.form.ApellidoPaterno
            },
            {
                 propiedad: "apellido_materno__c",
                 valor:this.form.ApellidoMaterno
            },
            {
                 propiedad: "firstname",
                 valor:this.form.Nombre
            },
            {
                 propiedad: "id_escuela_banner__c",
                 valor:this.form.IdSchool
            },
             {
                 propiedad: "nombre_escuela",
                 valor:this.EscuelaEmpresa
            },
             {
                 propiedad: "turno",
                 valor:"Matutino"
            },
             {
                 propiedad: "tipo_de_escuela__c",
                 valor:tyschool
            },
            {
                 propiedad: "ea_tipo_usuario",
                 valor:typeuser
            },
            {
                 propiedad: "ea_testid",
                 valor:testId
            },
            {
                 propiedad: "ea_portal_unitec",
                 valor:"educando"
            }
         ]
     }
    var urlcrm= this.urlpostcrm
    axios.post(urlcrm, this.form,config).then((result) => {
        this.showdloading = true;
     console.log(result.data.scribeResponse[0].exito);
     if(result.data.scribeResponse[0].exito == 1){
        var urlhub= this.urlposthub
         axios.post(urlhub, this.recordseedhub,configdos).then((result2) => {
            console.log(this.recordseedhub);
            this.recordloghub = {
            email: this.form.CorreoElectronico,   
            recordset: this.recordseedhub
            }
            axios.post(this.urlgeneral+"/api/guardar_log_formulario_hub", this.recordloghub,configdos).then((result3) => {
                console.log(result3);
            })
            console.log(result2);
             this.showdloading = false;
            this.showdiv = true;
            this.showform = false;
            this.isLoading = false;
        }) 
     }
     else{
        this.recordlogerrorcrm= {
            email: this.form.CorreoElectronico,   
            recordset: this.form,
            response: result.data.scribeResponse[0].mensaje,
            bandera: "ERROR",
            }
            axios.post(this.urlgeneral+"/api/guardar_log_formulario", this.recordlogerrorcrm,configdos).then((result3) => {
                console.log(result3);
            })
     }
     }) 
 
 });
},
    notEmpty(e) {
    var inputvalue = e.target.value;
    var permitidos = 2;
    var onlyConsonantes = false;
    var onlyVowels = false;
    var oneVowel = false;
    var oneConsonante = false;
    onlyVowels = inputvalue.match(/([aeiouAEIOUÁáÉéÍíÓóÚú]){3}/g) !== null;
    onlyConsonantes = inputvalue.match(/([b-df-hj-np-tv-zB-DF-HJ-NP-TV-Z-Ññ]){4}/g) !== null;
    oneVowel = inputvalue.match(/([aeiouAEIOUÁáÉéÍíÓóÚú])/g) === null;
    oneConsonante = inputvalue.match(/([b-df-hj-np-tv-zB-DF-HJ-NP-TV-Z-Ññ])/g) === null;
    //consulta del campus basura
    const url =this.urlgeneral+"/api/jsonBasura";
    axios.get( url )
    .then(response => {
    const products = response.data;
    for (var i in products){
    if (inputvalue.search(products[i].crmit_name) !== -1 || inputvalue.search(products[i].crmit_name) !== -1) {
    this.showSpan = false;
    this.showBorder = true;
    this.textoone = 'El valor (valor capturado) es un dato incorrecto';
    this.form.Nombre= '';
    }
    }
    });

     if (inputvalue === '') {
        this.textoone = 'No puede estar vacío el campo Nombre';
        this.showSpan = false;
        this.showBorder = true;
     }

    else if (onlyVowels && oneConsonante) {
        this.showSpan = false;
        this.showBorder = true;
        this.textoone = 'No se puede ingresar puras consonantes o puras vocales';
        this.form.Nombre= '';
        }

    else if (onlyConsonantes && oneVowel) {
        this.showSpan = false;
        this.showBorder = true;
        this.textoone = 'No se puede ingresar puras consonantes o puras vocales';
        this.form.Nombre= '';
    }

    else if (inputvalue.length <= permitidos) {
        this.showSpan = false;
        this.showBorder = true;
        this.textoone = 'El campo no cumple con la longitud mínima requerida';
        this.form.Nombre= '';
     }
     
     else{
        var nombre= this.form.Nombre;
        this.form.Nombre = nombre.trim();
        this.showSpan = true;
        this.showBorder = false;
     }
    },

notEmptyap(e) {
    var inputvalue = e.target.value;
    var permitidos = 2;
    var onlyConsonantes = false;
    var onlyVowels = false;
    var oneVowel = false;
    var oneConsonante = false;
    onlyVowels = inputvalue.match(/([aeiouAEIOUÁáÉéÍíÓóÚú]){3}/g) !== null;
    onlyConsonantes = inputvalue.match(/([b-df-hj-np-tv-zB-DF-HJ-NP-TV-Z-Ññ]){4}/g) !== null;
    oneVowel = inputvalue.match(/([aeiouAEIOUÁáÉéÍíÓóÚú])/g) === null;
    oneConsonante = inputvalue.match(/([b-df-hj-np-tv-zB-DF-HJ-NP-TV-Z-Ññ])/g) === null;
    //consulta del campus basura

   const url =this.urlgeneral+"/api/jsonBasura";
    axios.get( url )
    .then(response => {
    const products = response.data;
    for (var i in products){
    if (inputvalue.search(products[i].crmit_name) !== -1 || inputvalue.search(products[i].crmit_name) !== -1) {
    this.showSpanap = false;
    this.showBorderap = true;
    this.textapp = 'El valor (valor capturado) es un dato incorrecto';
    this.form.ApellidoPaterno= '';
    }
    }
    });

     if (inputvalue === '') {
        this.textapp = 'No puede estar vacío el campo Apellido Paterno';
        this.showSpanap = false;
        this.showBorderap = true;
     }
 
    else if (onlyVowels && oneConsonante) {
        this.showSpanap = false;
        this.showBorderap = true;
        this.textapp = 'No se puede ingresar puras consonantes o puras vocales';
        this.form.ApellidoPaterno = '';
    }

    else if (onlyConsonantes && oneVowel) {
        this.showSpanap = false;
        this.showBorderap = true;
        this.textapp = 'No se puede ingresar puras consonantes o puras vocales';
        this.form.ApellidoPaterno = '';
    }

      else if (inputvalue.length <= permitidos) {
        this.showSpanap = false;
        this.showBorderap = true;
        this.textapp = 'El campo no cumple con la longitud mínima requerida';
        this.form.ApellidoPaterno = '';
     }
     
     else{
        var nombre= this.form.ApellidoPaterno;
        this.form.ApellidoPaterno = nombre.trim();
        this.showSpanap = true;
        this.showBorderap = false;
     }
    },
    notEmptyam(e) {
    var inputvalue = e.target.value;
    var permitidos = 2;
    var onlyConsonantes = false;
    var onlyVowels = false;
    var oneVowel = false;
    var oneConsonante = false;
    onlyVowels = inputvalue.match(/([aeiouAEIOUÁáÉéÍíÓóÚú]){3}/g) !== null;
    onlyConsonantes = inputvalue.match(/([b-df-hj-np-tv-zB-DF-HJ-NP-TV-Z-Ññ]){4}/g) !== null;
    oneVowel = inputvalue.match(/([aeiouAEIOUÁáÉéÍíÓóÚú])/g) === null;
    oneConsonante = inputvalue.match(/([b-df-hj-np-tv-zB-DF-HJ-NP-TV-Z-Ññ])/g) === null;
    //consulta del campus basura

   const url =this.urlgeneral+"/api/jsonBasura";
    axios.get( url )
    .then(response => {
    const products = response.data;
    for (var i in products){
    if (inputvalue.search(products[i].crmit_name) !== -1 || inputvalue.search(products[i].crmit_name) !== -1) {
    this.showSpanam = false;
    this.showBorderam = true;
    this.textam = 'El valor (valor capturado) es un dato incorrecto';
    this.form.ApellidoMaterno= '';
    }
    }
    });

     if (inputvalue === '') {
        this.textam = 'No puede estar vacío el campo Apellido Materno';
        this.showSpanam = false;
        this.showBorderam = true;
     }

    else if (onlyVowels && oneConsonante) {
        this.showSpanam = false;
        this.showBorderam = true;
        this.textam = 'No se puede ingresar puras consonantes o puras vocales';
        this.form.ApellidoMaterno = '';
        }

    else if (onlyConsonantes && oneVowel) {
        this.showSpanam = false;
        this.showBorderam = true;
        this.textam = 'No se puede ingresar puras consonantes o puras vocales';
        this.form.ApellidoMaterno = '';
    }

      else if (inputvalue.length <= permitidos) {
        this.showSpanam = false;
        this.showBorderam = true;
        this.textam = 'El campo no cumple con la longitud mínima requerida';
        this.form.ApellidoMaterno = '';
     }
     
     else{
        var nombre= this.form.ApellidoMaterno;
        this.form.ApellidoMaterno = nombre.trim();
        this.showSpanam = true;
        this.showBorderam = false;
     }
    },
   notEmptytl(e) {
     var inputvalue = e.target.value;
     var stringReal = e.target.value.split("");
     var permitidos = 6;
     var stringNum = "";
     stringNum += e.target.value + e.key;
     var matches = stringNum.match(/([0-9])\1*/g) || [];
     var lastInput = matches.length > 0 ? matches[matches.length - 1].length : 0;
     //let stringNumero = value.toString();

     var correo = this.form.CorreoElectronico;
    if(correo == ""){
    this.disablePhone = true;
    }

    else{
      this.disablePhone = false;  
    }

     if (inputvalue === '') {
        this.showSpantl = false;
        this.showBordertl = true;
        this.textotel = 'El teléfono no puede estar vacío';
     }
     else if(stringReal[0] == 0 || e.keyCode == 101 || e.keyCode == 45 || e.keyCode == 43 || e.keyCode == 46){
            this.showSpantl = false;
            this.showBordertl = true;
            this.textotel = 'El teléfono no puede comenzar con cero o con un valor especial';
            this.form.Telefono = '';
            e.preventDefault();
     }
    else if(lastInput >= permitidos){
            this.showSpantl = false;
            this.showBordertl = true;
            this.textotel = 'No se deben capturar números con 6 dígitos iguales';
            this.form.Telefono = '';
     }
     else{
        let config = {
            headers: {
            'XApiKey': "3oW9sVxPqL8dK76t~RfGh2ZmNjBvC5a",
            }
            }
            var url = "https://crm-it-ws-cofetel.azurewebsites.net/ValidaCofetel?telefono="+inputvalue;
            axios.get(url,config)
            .then(response => {
            let dataDummy = response.data;
            var respuesta = dataDummy;
            if(respuesta.RespuestaCofetel === true){
                this.form.TelCelularMarcableCOFETEL = "true";
            }else{
                this.form.TelCelularMarcableCOFETEL = "false";
            }
            if(respuesta.RespuestaRepep === true){
                this.form.TelCelularMarcableREPEP = "true";
            }else{
                this.form.TelCelularMarcableREPEP = "false";
            }   
            if(respuesta.RespuestaRepep === false){
            this.form.Marcable = "false";
            e.preventDefault();
            }
    else{
        this.form.Marcable = "true";
        const url =this.urlgeneral+"/json/telefonosBasura.min.json";
    axios.get( url )
    .then(response => {
    const products = response.data;
    var a = products.filter(a => a.includes(inputvalue));
    var numero = a;
    if(numero == ""){
    this.showSpantl = true;
    this.showBordertl = false; 
    }
    else{
     this.showSpantl = false;
    this.showBordertl = true;
    this.textotel = 'Teléfono inválido';
    this.form.Telefono = ''; 
    }
 
 });


    }
    });
    }
    },
     notEmptyEmail(e) {
        var inputvalue = e.target.value;
    console.log(inputvalue);
    var urlvalidate= this.urlvalidatemailposthub
    var email = this.form.CorreoElectronico;
    let configvalidate = {
    headers: {
    'Content-type': "application/json",
    }
    }
    this.recordvalidate = {
        correo: email,   
    }
    axios.post(urlvalidate, this.recordvalidate,configvalidate).then((result) => {
    console.log(result.data);
    console.log(result.data.escorreovalido);
    if(result.data.escorreovalido == true  || result.data.escorreovalido == "true"){
        this.showSpanco2 = true;
        this.showBorderco = false;
        this.textcorreo = ''
      this.form.CorreoElectronicoCorrecto = "true"
    }else{
        this.showSpanco2 = false;
        this.showBorderco = true;
        this.textcorreo = result.data.error;
        this.form.CorreoElectronico = '';  
    }
    }) 
},
     notEmptyNumber(e) {
     var inputvalue = e.target.value;
     var inputlenght = e.target.value.length;
     if(inputlenght<3){
     alert("El numero tiene que estar compuesto por 10 digitos");
     }
     if (inputvalue === '') {
            alert("El campo no puede estar vacio");
     }
     else{
         //console.log("no esta entrando al if"); 
     }
     //console.log(inputvalue);
},
     isLetter(e) {
    var permitidos = 3;
    var stringNum = "";
    stringNum += e.target.value + e.key;
    var matches = stringNum.match(/([aeiouAEIOUÁáÉéÍíÓóÚú])\1*/ig) || [];
    var matchesConsonantes = stringNum.match(/([b-df-hj-np-tv-zB-DF-HJ-NP-TV-Z-Ññ])\1*/ig) || [];
    var lastInput = matches.length > 0 ? matches[matches.length - 1].length : 0;
    var lastInputConsonantes = matchesConsonantes.length > 0 ? matchesConsonantes[matchesConsonantes.length - 1].length : 0;
    
    if (lastInput === permitidos || lastInputConsonantes === permitidos) {
         this.showSpan = false;
        this.showBorder = true;
        this.textoone = 'No se permiten ingresar 3 letras Consecutivas';
        e.preventDefault();  
    }
    var stringReal = e.target.value.split("");
    if (stringReal[0] == " " || stringReal[0] == 32) {
    this.showSpan = false;
    this.showBorder = true;
    this.textoone = 'No se permiten espacios vacíos al inicio';
    e.preventDefault();
    }

    let char = String.fromCharCode(e.keyCode); // Get the character
     if(/^[A-Za-z-Ññ\s]+$/.test(char)) return true; // Match with regex 
    

     else e.preventDefault(); // If not match, don't add to input text
     },

    isLetterap(e) {
    var permitidos = 3;
    var stringNum = "";
    stringNum += e.target.value + e.key;
    var matches = stringNum.match(/([aeiouAEIOUÁáÉéÍíÓóÚú])\1*/ig) || [];
    var matchesConsonantes = stringNum.match(/([b-df-hj-np-tv-zB-DF-HJ-NP-TV-Z-Ññ])\1*/ig) || [];
    var lastInput = matches.length > 0 ? matches[matches.length - 1].length : 0;
    var lastInputConsonantes = matchesConsonantes.length > 0 ? matchesConsonantes[matchesConsonantes.length - 1].length : 0;
    
    if (lastInput === permitidos || lastInputConsonantes === permitidos) {
         this.showSpanap = false;
        this.showBorderap = true;
        this.textapp = 'No se permiten ingresar 3 letras Consecutivas';
        e.preventDefault();  
    }
    var stringReal = e.target.value.split("");
    if (stringReal[0] == " " || stringReal[0] == 32) {
    this.showSpanap = false;
    this.showBorderap = true;
    this.textapp = 'No se permiten espacios vacíos al inicio';
    e.preventDefault();
    }
    let char = String.fromCharCode(e.keyCode); // Get the character
     if(/^[A-Za-z-Ññ\s]+$/.test(char)) return true; // Match with regex 
     else e.preventDefault(); // If not match, don't add to input text
     },
     isLetteramm(e) {
    var permitidos = 3;
    var stringNum = "";
    stringNum += e.target.value + e.key;
    var matches = stringNum.match(/([aeiouAEIOUÁáÉéÍíÓóÚú])\1*/ig) || [];
    var matchesConsonantes = stringNum.match(/([b-df-hj-np-tv-zB-DF-HJ-NP-TV-Z-Ññ])\1*/ig) || [];
    var lastInput = matches.length > 0 ? matches[matches.length - 1].length : 0;
    var lastInputConsonantes = matchesConsonantes.length > 0 ? matchesConsonantes[matchesConsonantes.length - 1].length : 0;
    
    if (lastInput === permitidos || lastInputConsonantes === permitidos) {
         this.showSpan = false;
        this.showBorder = true;
        this.textoone = 'No se permiten ingresar 3 letras Consecutivas';
        e.preventDefault();  
    }
    var stringReal = e.target.value.split("");
    if (stringReal[0] == " " || stringReal[0] == 32) {
    this.showSpan = false;
    this.showBorder = true;
    this.textoone = 'No se permiten espacios vacíos al inicio';
    e.preventDefault();
    }

    let char = String.fromCharCode(e.keyCode); // Get the character
     if(/^[A-Za-z-Ññ\s]+$/.test(char)) return true; // Match with regex 
    

     else e.preventDefault(); // If not match, don't add to input text
     },

    isLetteram(e) {
    var permitidos = 3;
    var stringNum = "";
    stringNum += e.target.value + e.key;
    var matches = stringNum.match(/([aeiouAEIOUÁáÉéÍíÓóÚú])\1*/ig) || [];
    var matchesConsonantes = stringNum.match(/([b-df-hj-np-tv-zB-DF-HJ-NP-TV-Z-Ññ])\1*/ig) || [];
    var lastInput = matches.length > 0 ? matches[matches.length - 1].length : 0;
    var lastInputConsonantes = matchesConsonantes.length > 0 ? matchesConsonantes[matchesConsonantes.length - 1].length : 0;
    
    if (lastInput === permitidos || lastInputConsonantes === permitidos) {
         this.showSpanam = false;
        this.showBorderam = true;
        this.textam = 'No se permiten ingresar 3 letras Consecutivas';
        e.preventDefault();  
    }
    var stringReal = e.target.value.split("");
    if (stringReal[0] == " " || stringReal[0] == 32) {
    this.showSpanam = false;
    this.showBorderam = true;
    this.textam = 'No se permiten espacios vacíos al inicio';
    e.preventDefault();
    }
    let char = String.fromCharCode(e.keyCode); // Get the character
     if(/^[A-Za-z-Ññ\s]+$/.test(char)) return true; // Match with regex 
     else e.preventDefault(); // If not match, don't add to input text
     },
    isLetterg(e) {
     let char = String.fromCharCode(e.keyCode); // Get the character
     if(/^[A-Za-z-Ññ\s]+$/.test(char)) return true; // Match with regex 
     else e.preventDefault(); // If not match, don't add to input text
     },
}
}
</script>
<style scoped>
.span {
   display: none;
}
.bodername{
    border:1px solid #b11026;
}
.lblname{
    color: #b11026;
}
.lblap{
    color: #b11026;
}
.lblam{
    color: #b11026;
}
.lbltel{
    color: #b11026;
}
.lblco{
    color: #b11026;
}
.spanap {
   display: none;
}
.boderap{
    border:1px solid #b11026;
}
.spanam {
   display: none;
}
.boderam{
    border:1px solid #b11026;
}
.spantl {
   display: none;
}
.bodertl{
    border:1px solid #b11026;
}
.spanco {
   display: none;
}
.spanco2 {
   display: none;
}
.boderco{
    border:1px solid #b11026;
}
.cardForm {

  border-radius: 6px;
  box-shadow: 0 11px 24px 0 #b0d3eb;
  border: solid 1px #5eabe0;
  background-color: white;
  border-top: solid 8px #0d6eba;
  padding: 24px;
  width: 40%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 45px;
  
  
  }
  @media only screen and (max-width: 880px) {
      .cardForm {
        width: 80%;
      }
  }

.inputControl {
  position: relative;
   margin-top: 30px;
    display: flex;
}
label {
    color: #0d6eba;
    background: white;
    font-size: 14px;
    font-weight: bold;
    position: absolute;
    top: -9px;
    left: 9px;
    padding: 0 8px;
  }

  input {
    border-radius: 6px;
    border: solid 1px #5eabe0;
    background-color: white;
    padding: 10px 16px;
    padding-right: 35px;
    width: 100%;
    font-size: 16px;
    color:  #505050;

   
  }

   button {
    width: 100%;
    margin-top: 20px;
    text-align: center;
  }

   h2 {
      margin-top: 5px;
      margin-bottom: 25px;
      color:#0d6eba;
      font-weight:700;
      font-size:24px;
    }
    .cmp-button{
        appearance:none;
        border-radius: 3px;
        cursor:pointer;
        font-size:18px;
        padding:9pt 14px 14px;
        text-align:center;
        font-weight:500;
        background-color:#f68b1f;
        border: 1px solid #f68b1f;
        color:#003053!important;
        transition:background-color .4s ease-out,color .3s ease-out,border .4s ease-out;
    }
</style>